import React, { PureComponent } from 'react'
import { Button, H1 } from "@drifthq/tide-core"
import { getDefaultConfig } from 'utils/password'
import PasswordInput from 'components/PasswordInput'
import EmailInput from 'components/EmailInput'

import './style.css'

const canSave = ({ isPasswordValid, isEmailValid, email }) => {
  return isPasswordValid && isEmailValid && !!email.length
}

class DealCreateAccountStep extends PureComponent {
  componentDidMount() {
    this.props.onInitPasswordCheck(this.props.password)
  }

  render() {
    const {
      email,
      password,
      buttonName,
      isProcessing,
      onNextClicked,
      onEmailUpdated,
      onPasswordUpdated,
      isEmailValid,
      isPasswordValid,
      emailHasInvalidDomain,
    } = this.props

    return (
      <div className="deal-create-account-step">
        <H1>Create your admin account</H1>
        <div className="deal-create-account-step-form">
          <EmailInput
            placeholder={"you@company.com"}
            personal={emailHasInvalidDomain}
            onChange={onEmailUpdated}
            value={email}
            label={'Admin email'}
            unique={true}
            valid={isEmailValid}
            type={"email"}
            hideError={false}
            createOrgError={false}
          />
          <PasswordInput
            value={password}
            onChange={onPasswordUpdated}
            passwordConfig={getDefaultConfig()}
            passwordConfigFetched={true}
            passwordUpdateStatus={null}
          />
          <Button size="large" loading={isProcessing}
            type="primary"
            disabled={!canSave({ isPasswordValid, isEmailValid, email })}
            onClick={onNextClicked}>
            {buttonName}
          </Button>
        </div>
      </div>
    )
  }
}

export default DealCreateAccountStep



// WEBPACK FOOTER //
// ./src/layouts/Deal/CreateAccountStep/component.js